import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=3d81e0fc&scoped=true"
import script from "./mine.vue?vue&type=script&lang=js"
export * from "./mine.vue?vue&type=script&lang=js"
import style0 from "./mine.vue?vue&type=style&index=0&id=3d81e0fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d81e0fc",
  null
  
)

export default component.exports